import { type } from '@/utils/type'


export const FLEET_UNSELECT = type('FLEET_UNSELECT')

export const FLEET_SELECT_DETAIL_REQUEST = type('FLEET_SELECT_DETAIL_REQUEST')
export const FLEET_SELECT_DETAIL_SUCCESS = type('FLEET_SELECT_DETAIL_SUCCESS')
export const FLEET_SELECT_DETAIL_ERROR = type('FLEET_SELECT_DETAIL_ERROR')
export const FLEET_SELECT_DETAIL = type('FLEET_SELECT_DETAIL')
export const FLEET_SET_LEFTPANEL_SIZE = type('FLEET_SET_LEFTPANEL_SIZE')

export const FLEET_UPDATE_DETAIL_SUCCESS = type('FLEET_UPDATE_DETAIL_SUCCESS')


export const FLEET_UNSELECT_DETAIL = type('FLEET_UNSELECT_DETAIL')
export const FLEET_NAVTO_DETAIL = type('FLEET_NAVTO_DETAIL')
export const FLEET_UNSELECT_TAB = type('FLEET_UNSELECT_TAB')
export const FLEET_MOVE_TAB = type('FLEET_MOVE_TAB')
export const FLEET_RENAME_DETAIL = type('FLEET_RENAME_DETAIL')

export const FLEET_SET_ONGOING_FILTER = type('FLEET_SET_ONGOING_FILTER')
export const FLEET_RESET_FILTER = type('FLEET_RESET_FILTER')

export const FLEET_ADD_CONSOLE_ROW = type('FLEET_ADD_CONSOLE_ROW')
export const FLEET_CLEAR_CONSOLE = type('FLEET_CLEAR_CONSOLE')

export const FLEET_END = type('FLEET_END')


